function logPerformance (measures) {
  if (!Array.isArray(measures)) {
    measures = [measures]
  }
  const metrics = measures.map(measure => {
    const { name, duration: value } = measure
    const metric = ['client', ...name.split(':')].join('.')
    return {
      type: 'timing',
      metric,
      value
    }
  })
  return this.logClientEvent(metrics)
}

function install (Vue) {
  Vue.prototype.$logPerformance = logPerformance
}

export default {
  install,
  logPerformance
}
